import {keepPreviousData, queryOptions, useQuery} from '@tanstack/react-query'
import { DateRange } from 'react-day-picker'

import * as apiClient from '@/lib/api'
import { ROLES } from '@/lib/auth/roles'
import { formatDate } from '@/lib/filters/date/date-utils'
import useIsQueryEnabled from '@/lib/hooks/query-enabler';
import {useQueryResetWithRefresh} from "@/lib/hooks/query-refetch-with-reset";
import { ElevationByAdviserScores } from '@/modules/elevation-by-adviser/types'
import { useDate } from '@/stores/date-filter'
import { useServiceType } from '@/stores/service-type'
import { useToken } from '@/stores/token'
import { QUERY_KEY_ELEVATION_BY_ADVISER_SCORES } from '@/utils/keys'

function fetchElevationByAdviserScores(date: DateRange, serviceType: number | null): Promise<ElevationByAdviserScores> {
  const to = formatDate(date.to, 'yyyy-MM-dd')
  const from = formatDate(date.from, 'yyyy-MM-dd')

  return apiClient.get(`/firm/elevation/scores/scores-by-adviser?&to=${to}&from=${from}&service_type_id=${serviceType}`)
}

export const elevationByAdviserScoresQueryOptions = (
  date: DateRange,
  serviceType: number | null
) =>
  queryOptions({
    queryKey: [QUERY_KEY_ELEVATION_BY_ADVISER_SCORES, date, serviceType],
    queryFn: () => fetchElevationByAdviserScores(date, serviceType),
    placeholderData: keepPreviousData
  });

export const useElevationByAdviserScores = () => {
  const { date } = useDate()
  const { token } = useToken()
  const { serviceType } = useServiceType()
  
  const queryOptions = elevationByAdviserScoresQueryOptions(date, serviceType)
  queryOptions.enabled = useIsQueryEnabled(!!(token?.roles.includes(ROLES.ROLE_ELEVATION) && serviceType))

  const query = useQuery(queryOptions)
  const { resetAndRefetch } = useQueryResetWithRefresh(queryOptions.queryKey, query.refetch)

  return {
    data: query.data,
    isLoading: query.isLoading,
    isFetching: query.isFetching,
    isPlaceholderData: query.isPlaceholderData,
    isError: query.isError,
    isRefetchError: query.isRefetchError,
    error: query.error,
    isRefetching: query.isRefetching,
    isSuccess: query.isSuccess,
    status: query.status,
    refetch: resetAndRefetch
  }
}


